import { AxiosError } from 'axios'
import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import dashboardApi from '../../middleware/api/Dashboard/dashboardApi'
import { LoadingState, ValidationError } from '../../types/commonTypes'
import { ApiLoadingState } from '../../middleware/api/apiList'
import {
  EmployeeServiceAnniversariesSliceState,
  ServiceAnniversaries,
  ServiceAnniversariesApiProps,
} from '../../types/Dashboard/ServiceAnniversaries/serviceAnniversaries'
import { RootState } from '../../stateStore'

const getUpcomingServiceAnniversaries = createAsyncThunk(
  'serviceAnniversaries/getUpcomingServiceAnniversaries',
  async (props: ServiceAnniversariesApiProps, thunkApi) => {
    try {
      return await dashboardApi.getUpcomingServiceAnniversaries(props)
    } catch (error) {
      const err = error as AxiosError
      return thunkApi.rejectWithValue(err.response?.status as ValidationError)
    }
  },
)

export const initialUpcomingServiceAnniversariesListState: EmployeeServiceAnniversariesSliceState =
  {
    listSize: 0,
    isLoading: ApiLoadingState.idle,
    upcomingServiceAnniversaries: [],
    error: null,
  }

const serviceAnniversarySlice = createSlice({
  name: 'serviceAnniversaries',
  initialState: initialUpcomingServiceAnniversariesListState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getUpcomingServiceAnniversaries.fulfilled, (state, action) => {
        state.isLoading = ApiLoadingState.succeeded
        state.upcomingServiceAnniversaries = action.payload.list
        state.listSize = action.payload.size
      })

      .addCase(getUpcomingServiceAnniversaries.pending, (state) => {
        state.isLoading = ApiLoadingState.loading
      })
  },
})

const upcomingServiceAnniversaries = (
  state: RootState,
): ServiceAnniversaries[] =>
  state.upcomingServiceAnniversaries.upcomingServiceAnniversaries

const listSize = (state: RootState): number =>
  state.upcomingServiceAnniversaries.listSize

const isLoading = (state: RootState): LoadingState =>
  state.upcomingServiceAnniversaries.isLoading

const upcomingServiceAnniversaryThunk = {
  getUpcomingServiceAnniversaries,
}

const upcomingServiceAnniversarySelectors = {
  upcomingServiceAnniversaries,
  listSize,
  isLoading,
}

export const upcomingServiceAnniversaryService = {
  ...upcomingServiceAnniversaryThunk,
  actions: serviceAnniversarySlice.actions,
  selectors: upcomingServiceAnniversarySelectors,
}

export default serviceAnniversarySlice.reducer
